import "./App.css";
import { useState } from "react";
import { Button, Scrollbar } from "retro-react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import SpotifyAddSongsPrompt from "./SpotifyAddSongsPrompt";
import { Link } from "react-router-dom";
import NoMobile90sWrapper from "./NoMobile90sWrapper";

const ScreenContainer = (props: React.PropsWithChildren) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const { t, i18n } = useTranslation();
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <NoMobile90sWrapper>
      <div className="container">
        <button className="hamburger" onClick={toggleMenu}>
          ☰ Menu
        </button>
        <nav className={`sidebar ${menuOpen ? "open" : ""}`}>
          <LanguageSwitcher />
          <Link to={`/${i18n.language}`}>
            <Button
              color="primary"
              size="medium"
              variant="solid"
              style={{
                width: "100%",
                marginBottom: 15,
              }}
            >
              {t("navHome")}
            </Button>
          </Link>
          <Link to={`/${i18n.language}/dresscode`}>
            <Button
              color="primary"
              size="medium"
              variant="solid"
              style={{
                width: "100%",
                marginBottom: 15,
              }}
            >
              {t("navDresscode")}
            </Button>
          </Link>
          <Link to={`/${i18n.language}/what-to-do`}>
            <Button
              color="primary"
              size="medium"
              variant="solid"
              style={{
                width: "100%",
                marginBottom: 15,
              }}
            >
              {t("navActivitiesAround")}
            </Button>
          </Link>
          <Link to={`/${i18n.language}/what-to-bring`}>
            <Button
              color="primary"
              size="medium"
              variant="solid"
              style={{
                width: "100%",
                marginBottom: 15,
              }}
            >
              {t("navWhatToBring")}
            </Button>
          </Link>
          <Link to={`/${i18n.language}/whats-covered`}>
            <Button
              color="primary"
              size="medium"
              variant="solid"
              style={{
                width: "100%",
                marginBottom: 15,
              }}
            >
              {t("navWhatsCovered")}
            </Button>
          </Link>
        </nav>
        <Scrollbar theme="pastel">
          <main className="content">
            {props.children}
            <div style={{ height: 100 }}></div>
          </main>
        </Scrollbar>
        <SpotifyAddSongsPrompt />
      </div>
    </NoMobile90sWrapper>
  );
};

export default ScreenContainer;
